// Package Imports
import { useSimpleList } from '@refinedev/antd';
import { BaseRecord, useTranslate } from '@refinedev/core';

// Project Imports
import apiEndpoint from 'core/common/apiEndPoints';
import replacePipe from 'core/utils/replacePipe';

export default function getUnifiedColumnList(id) {
  const t = useTranslate();

  const { listProps: unifiedOptions } = useSimpleList({
    dataProviderName: 'unifiedDataProvider',
    resource: `${apiEndpoint.dataSourceColumnList}/?id=${id}&source_type=unified`,
    meta: {
      type: 'select',
    },
    pagination: {
      mode: 'off',
    },
    queryOptions: {
      enabled: !!id,
    },
    errorNotification: (data: BaseRecord) => {
      const message =
        replacePipe(data?.message) || t('notifications.errorMessage');
      return {
        message: 'Error Message',
        description: message,
        type: 'error',
      };
    },
  });
  const responseData = (unifiedOptions?.dataSource as any)?.column_list;
  const unifiedList = responseData?.map((item) => ({
    label: item.label,
    value: item.unique_id,
    data_type: item.data_type,
    default_value: item.default_value,
    unique_id: item.unique_id,
  }));
  return unifiedList;
}
